<template>
    <div>
        <VueApexCharts v-if="!this.$apollo.loading" type="bar" :options="options" :series="series"></VueApexCharts>
    </div>
</template>

<script>
    import BAR_CHART_GET from "../../graphql/BarChartGet.gql";
    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {VueApexCharts},
        data() {
            return {
                options: {
                    chart: {
                        type: 'bar',
                        height: 350
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: 'top', // top, center, bottom
                            },
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: this.formatCurrency,
                        offsetY: -20,
                        style: {
                            fontSize: '12px',
                            colors: ["#304758"]
                        }
                    },
                    xaxis: {
                        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                        position: 'bottom',
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        },
                        crosshairs: {
                            fill: {
                                type: 'gradient',
                                gradient: {
                                    colorFrom: '#D8E3F0',
                                    colorTo: '#BED1E6',
                                    stops: [0, 100],
                                    opacityFrom: 0.4,
                                    opacityTo: 0.5,
                                }
                            }
                        },
                        tooltip: {
                            enabled: true,
                        }
                    },
                    yaxis: {
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        labels: {
                            show: false,
                            formatter: this.formatCurrency
                        }

                    },
                    fill: {
                        opacity: 1
                    },
                }
            }
        },
        computed: {

            series() {
                return this.barData[0].series;
            },

        },
        apollo: {
            barData: {
                query: BAR_CHART_GET,
                variables() {
                    return {
                        type: this.type,
                        params: this.params
                    }
                },
                update: data => data.barChart
            },
        },

        props: {
            type: String,
            params: Object,
        },
        methods: {
            formatCurrency(amount) {

                const formatter = new Intl.NumberFormat('en-GB', {
                    style: 'currency',
                    currency: 'GBP',
                    minimumFractionDigits: 0
                });
                return formatter.format(amount);

            }
        }
    }
</script>

<style scoped>

</style>